var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-root mc-customer-return"},[_c('div',{staticClass:"mc-page"},[_c('mc-page-header',{attrs:{"title":"Ricevimento resi cliente"}}),_c('customer-return-create',{on:{"created":_vm.refreshRecentReturns}}),_c('customer-return-generation'),_c('customer-return-recent',{ref:"recentReturns"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }